module.exports = __webpack_public_path__ + "static/media/ebuilt-promo-sale-homes-banner-mobile.a57b03f2.webp";